import funcion from './funcion/siap'
import catalogos from "./catalogos/siap";


const funciones = {
  funcion: funcion,
  catalogos:catalogos
}

export default funciones;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/siap/siapapi.js
// module id = null
// module chunks = 